<template>
  <div class="container" style="margin-bottom: 10px">
    <contrato-evolucion-report :token-auth="tokenAuth" />

    <div class="card" style="padding: 16px; margin-top: 16px">
      <div class="mb-2">
        <h5 style="margin: 0">Consulta individual</h5>
        <p style="margin: 4px 0 0; font-size: 12px; color: #7c7c7c">
          Consulta un contrato por número. El token y la llamada al API de Saludsa ocurren en el
            servidor.
          </p>
        </div>

      <div class="row align-items-end" style="margin-bottom: 10px">
        <div class="col-12 col-md-4">
          <label class="form-label" style="margin-top: 0">Nro. contrato</label>
          <input
            v-model.trim="nroConsultaIndividual"
            class="form-control"
            type="text"
            inputmode="numeric"
            placeholder="Ej. 12345"
            :disabled="loadingIndividual"
            @keyup.enter="onConsultarIndividual"
          />
        </div>
        <div class="col-12 col-md-auto d-flex gap-2 flex-wrap" style="padding-top: 8px">
          <button
            class="btn btn-primary btn-sm"
            type="button"
            @click="onConsultarIndividual"
            :disabled="loadingIndividual || !nroConsultaIndividual"
          >
            {{ loadingIndividual ? "Consultando..." : "Consultar" }}
          </button>
          <button
            class="btn btn-outline-secondary btn-sm"
            type="button"
            @click="limpiarConsultaIndividual"
            :disabled="loadingIndividual"
          >
            Limpiar respuesta
          </button>
        </div>
      </div>

      <div v-if="individualError" class="alert alert-danger py-2 px-3" style="font-size: 13px">
        {{ individualError }}
      </div>
      <div v-if="individualHttpStatus != null" class="mb-2">
        <small style="color: #7c7c7c">HTTP </small>
        <code>{{ individualHttpStatus }}</code>
      </div>
      <pre v-if="individualJsonText" class="contrato-json-pre"><code>{{ individualJsonText }}</code></pre>
    </div>
  </div>
</template>

<script>
import { getConsultasApiV1BaseURL } from "@/store/axios";
import ContratoEvolucionReport from "./ContratoEvolucionReport.vue";

export default {
  name: "ContratosAdmin",
  components: { ContratoEvolucionReport },
  props: {
    tokenAuth: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      nroConsultaIndividual: "",
      loadingIndividual: false,
      individualJsonText: "",
      individualHttpStatus: null,
      individualError: "",
    };
  },
  computed: {
    apiBase() {
      const base = getConsultasApiV1BaseURL();
      return base.endsWith("/") ? base : `${base}/`;
    },
  },
  methods: {
    limpiarConsultaIndividual() {
      this.individualJsonText = "";
      this.individualHttpStatus = null;
      this.individualError = "";
    },
    async onConsultarIndividual() {
      const nro = String(this.nroConsultaIndividual || "").trim();
      if (!nro || this.loadingIndividual) return;

      this.loadingIndividual = true;
      this.individualError = "";
      this.individualJsonText = "";
      this.individualHttpStatus = null;

      try {
        const params = new URLSearchParams({ contratoNumero: nro });
        const res = await fetch(
          `${this.apiBase}testing/Contrato/ObtenerContratoRefiereGana?${params.toString()}`,
        );
        const text = await res.text();
        this.individualHttpStatus = res.status;

        let display = text;
        try {
          const parsed = JSON.parse(text);
          display = JSON.stringify(parsed, null, 2);
        } catch {
          /* respuesta no JSON */
        }
        this.individualJsonText = display;

        if (!res.ok && this.$toast) {
          this.$toast.warning(`Respuesta HTTP ${res.status}`, {
            position: "top-right",
            max: 3,
          });
        } else if (this.$toast) {
          this.$toast.success("Consulta individual lista.", {
            position: "top-right",
            max: 3,
          });
        }
      } catch (e) {
        this.individualError = e?.message || String(e);
        if (this.$toast) {
          this.$toast.error(this.individualError, {
            position: "top-right",
            max: 3,
          });
        }
      } finally {
        this.loadingIndividual = false;
      }
    },
  },
};
</script>

<style scoped>
.form-label {
  margin-top: 10px;
  font-size: 13px;
  font-weight: 600;
}

.contrato-json-pre {
  margin: 0;
  padding: 12px;
  max-height: 420px;
  overflow: auto;
  font-size: 12px;
  line-height: 1.45;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  white-space: pre-wrap;
  word-break: break-word;
}

.contrato-json-pre code {
  color: #212529;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}
</style>
